import AbsoluteTimeframe from './AbsoluteTimeframe';

export default AbsoluteTimeframe;
